//
//
//
//
//
//
//
//
//

  import footerNav from '@/components/footer/footer'

  export default {
    data() {
      return {

      }
    },

    mounted() {
      this.$refs.contentFrame.src="http://v.youmi.cn/mobile/"
    },

    computed: {

    },

    components: {
      footerNav
    },

    methods: {

    }
  }





// WEBPACK FOOTER //
// ./src/view/entrepreneurship/entrepreneurship.vue